import getAxios from "./axiosService";

let STATICAPI = true;
let homeService = {
  getIndexPage() {
    return new Promise((resolve, reject) => {
      let axios = getAxios(STATICAPI);
      axios.get('/api/book/home/index')
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get index page with error', res);
            reject();
          }
        })
    })
  },
  getThreeDList() {
    return new Promise((resolve, reject) => {
      let axios = getAxios(STATICAPI);
      axios.get('/api/book/home/three_d')
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get threeDList with error', res);
            reject();
          }
        })
    })
  }
};

export default homeService



// WEBPACK FOOTER //
// ./src/services/homeService.js